import { Link } from "react-router-dom";
import { Award, Heart, Sparkles, ArrowRight, Mail, Globe, Instagram } from "lucide-react";

const MICKEY_PHOTO = "https://customer-assets.emergentagent.com/job_gen-connect-11/artifacts/hu9c4p2a_profile%20pic%20tucker.jpg";
const SHANIA_PHOTO = "https://customer-assets-wrfwihn1.emergentagent.net/job_gen-connect-11/artifacts/f549b59978801691_shania%20headshot.jpg";
const CHRIS_PHOTO = "https://customer-assets-wrfwihn1.emergentagent.net/job_gen-connect-11/artifacts/177782f19295c291_chris%20green.png";

const TEAM = [
  {
    id: "mickey-coffino",
    name: "Michelle Coffino",
    title: "Chief Executive Officer & Co-Founder",
    photo: MICKEY_PHOTO,
    photoCredit: "Vanessa Allen Photography",
    location: "Charlotte, NC",
    socials: [
      { icon: <Mail className="w-4 h-4" />, href: "mailto:mickey@generationalh.com", label: "mickey@generationalh.com" },
      { icon: <Globe className="w-4 h-4" />, href: "https://generationalh.com", label: "generationalh.com" },
      { icon: <Instagram className="w-4 h-4" />, href: "https://instagram.com/mickey_coffino", label: "@mickey_coffino" },
    ],
    accolades: [
      "Charlotte Business Journal — 50 Most Influential Women",
      "50 Women to Know in North Carolina",
      "North Carolina Hall of Fame Inductee",
      "Runner-up, NC Small Business Person of the Year",
      "Recognized by the U.S. Department of Energy for Workforce Development",
      "National Small Business Person of the Year finalist (Wells Fargo)",
      "Mother of triplets · Fierce advocate for generational change",
    ],
    bio: [
      "Co-Founder of Generational Health, a next-generation mental health platform engineered to become a billion-dollar leader in crisis care, behavioral health access, and technology-driven wellness.",
      "A high-performance operator and visionary builder, Coffino has built and scaled multiple businesses across diverse industries — consistently turning vision into revenue, and systems into impact. She is known for decisive leadership, rapid execution, and an uncompromising commitment to building at scale. She doesn't adapt to broken systems; she replaces them.",
      "Under her leadership, Generational Health is being developed as a fully integrated, HIPAA-compliant ecosystem delivering 24/7 crisis intervention, telehealth, peer support, and real-time mental health solutions. Her mission is to disrupt and rebuild the mental health infrastructure in America — making care immediate, accessible, and scalable across all communities.",
      "A core pillar of Coffino's vision is prison reform through mental health intervention. She is actively building pathways to bring structured mental health support, trauma-informed care, and reentry stabilization into correctional systems — addressing one of the most neglected drivers of recidivism. Her approach bridges the gap between incarceration and rehabilitation, positioning mental health care as a critical foundation for reducing repeat offenses and restoring individuals back into society with dignity and support.",
      "Coffino's leadership is grounded in lived experience. Raised in adversity and shaped by real-world challenges, she brings a level of grit, resilience, and emotional intelligence that translates into bold, effective decision-making. She leads with intensity, clarity, and purpose — building systems that are designed not only to perform, but to transform lives at scale.",
      "Generational Health is not just a company under her leadership — it is a category-defining movement at the intersection of healthcare, technology, and systemic reform. Beyond her professional achievements, Coffino is a mother of triplets and a fierce advocate for generational change. She operates with a clear belief: legacy is not inherited — it is built through discipline, vision, and execution.",
    ],
  },
  {
    id: "chris-green",
    name: "Chris Green",
    title: "Global Sales Director",
    photo: CHRIS_PHOTO,
    location: "Charlotte, NC",
    socials: [
      { icon: <Mail className="w-4 h-4" />, href: "mailto:chris@generationalh.com", label: "chris@generationalh.com" },
    ],
    accolades: [
      "Former Professional Baseball Player · Pittsburgh Pirates organization",
      "Founder & Owner, Visual Concepts Security",
      "Entrepreneur · Business Leader · Community Advocate",
      "Mentor and advocate for prison reform & second chances",
      "Champion of personal accountability, rehabilitation & empowerment",
    ],
    bio: [
      "Chris Green brings a powerful combination of professional athletic experience, entrepreneurial leadership, strategic relationship building, and a deep commitment to transforming lives to his role as Global Sales Director of Generational Health.",
      "A former professional baseball player with the Pittsburgh Pirates organization, Chris built his foundation on discipline, perseverance, teamwork, and the relentless pursuit of excellence. Those same principles have guided his transition from professional sports into business ownership, community leadership, and advocacy.",
      "As the founder and owner of Visual Concepts Security, Chris has established himself as an entrepreneur who understands the importance of trust, operational excellence, strategic partnerships, and building relationships that create lasting value.",
      "Beyond his business accomplishments, Chris is deeply committed to mentorship, prison reform, and creating opportunities for individuals seeking a second chance. His work reflects a fundamental belief that a person's past should never determine the limits of their future. Through mentorship and advocacy, he champions personal accountability, rehabilitation, empowerment, and pathways to meaningful change.",
      "At Generational Health, Chris will leverage his professional network, business development expertise, and passion for social impact to lead global sales initiatives, cultivate strategic partnerships, and expand access to innovative mental health and behavioral health solutions.",
      "His mission aligns with Generational Health's commitment to breaking down barriers to mental healthcare, reducing stigma, and bringing meaningful support to underserved and overlooked populations — including veterans, returning citizens, vulnerable youth, and individuals experiencing isolation.",
      "Working alongside founder and CEO Michelle (Mickey) Coffino and the Generational Health leadership team, Chris plays an integral role in positioning the organization for sustainable growth, strategic expansion, and long-term impact.",
      "Chris Green represents a new generation of leadership — one where business success is measured not only by revenue and growth, but by the lives transformed, opportunities created, and communities strengthened along the way.",
    ],
  },
  {
    id: "shania-oliver",
    name: "Shania Oliver, LCMHCA, LCASA",
    title: "Clinical Director",
    photo: SHANIA_PHOTO,
    location: "Charlotte, NC",
    socials: [],
    accolades: [
      "Licensed Clinical Mental Health Counselor Associate (LCMHCA)",
      "Licensed Clinical Addictions Specialist Associate (LCASA)",
      "Specialist in person-centered therapy, CBT & harm-reduction practices",
      "Leads GH's clinical vision and provider-quality standards",
    ],
    bio: [
      "Shania Oliver is a highly skilled and forward-thinking clinician redefining what modern mental health care should look like. As a Licensed Clinical Mental Health Counselor Associate and Licensed Clinical Addictions Specialist Associate, she brings a dynamic, evidence-based approach grounded in person-centered therapy, cognitive behavioral therapy (CBT), and harm-reduction practices.",
      "With a career built across multiple levels of the mental health system, Shania possesses a comprehensive understanding of both clinical care delivery and the structural gaps that impact access and outcomes. Her experience spans direct therapy, interdisciplinary collaboration, and hands-on work within complex care environments — giving her a rare, full-spectrum perspective on how to effectively support individuals navigating mental health and substance use challenges.",
      "What sets Shania apart is her commitment to intentional, individualized care. Her approach is shaped not only by professional expertise, but by lived experience — having personally navigated mental health systems that often lacked personalization and responsiveness. This perspective drives her mission to ensure that every individual receives care that is human-centered, culturally aware, and deeply attuned to their unique needs.",
      "As a mother, Shania brings an added layer of depth and empathy to her work, recognizing firsthand the profound mental, emotional, and identity shifts that life transitions can bring. She understands that mental wellness is not static — it evolves, and requires support systems that are equally adaptive.",
      "At Generational Health, Shania is a key force behind the organization's clinical vision: breaking generational cycles of trauma by delivering accessible, high-impact, and transformative mental health care. Her work is defined by one core principle: real healing happens when people feel seen, heard, and supported — without judgment.",
    ],
  },
];

function Avatar({ member }) {
  if (member.photo) {
    return (
      <img
        src={member.photo}
        alt={`${member.name} — ${member.title}`}
        className="w-full h-full object-cover"
        data-testid={`team-photo-${member.id}`}
      />
    );
  }
  return (
    <div
      className="w-full h-full flex items-center justify-center"
      style={{
        background: `linear-gradient(135deg, ${member.avatarColors.from} 0%, ${member.avatarColors.to} 100%)`,
      }}
      data-testid={`team-photo-${member.id}`}
    >
      <span className="font-display text-[10rem] text-white/95 leading-none tracking-tight">
        {member.initials}
      </span>
    </div>
  );
}

const PRESS_ITEMS = [
  {
    publication: "Charlotte Business Journal",
    quote: "50 Most Influential Women",
    sub: "Annual recognition of the women shaping Charlotte's business landscape.",
  },
  {
    publication: "Wells Fargo",
    quote: "National Small Business Person of the Year — Finalist",
    sub: "Recognition for entrepreneurial excellence at the national level.",
  },
  {
    publication: "U.S. Department of Energy",
    quote: "Workforce Development Recognition",
    sub: "For pioneering reentry-to-trades pathways through Queen City Metal Recycling.",
  },
  {
    publication: "NC Small Business Administration",
    quote: "NC Small Business Person of the Year — Runner-up",
    sub: "Statewide recognition for business growth and community impact.",
  },
  {
    publication: "South State Bank",
    quote: "Banking Partner — Generational Health Launch",
    sub: "Local banking support powering the Generational Health platform launch.",
  },
];

function PressBand() {
  return (
    <section className="mt-12 -mx-6 lg:-mx-10" data-testid="press-band">
      <div className="bg-gradient-navy rounded-none lg:rounded-[2rem] mx-0 lg:mx-0 p-10 lg:p-14 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-teal/15 rounded-full blur-3xl" aria-hidden="true" />
        <div className="relative max-w-5xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
            <div>
              <p className="eyebrow !text-teal mb-3">Press &amp; Recognition</p>
              <h3 className="font-display text-3xl sm:text-4xl text-white leading-[1.1]">
                Featured &amp; <span className="hl-teal">recognized by.</span>
              </h3>
            </div>
            <p className="text-white/60 text-sm sm:text-right max-w-xs">
              Mickey's work has been celebrated by leading institutions in business, government, and media.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {PRESS_ITEMS.map((p, i) => (
              <div
                key={i}
                className="bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-sm hover:bg-white/10 transition-colors"
                data-testid={`press-item-${i}`}
              >
                <p className="font-display text-lg text-white mb-2 leading-tight">{p.publication}</p>
                <p className="text-teal font-bold text-sm mb-2">{p.quote}</p>
                <p className="text-white/60 text-xs leading-relaxed">{p.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Team() {
  return (
    <div data-testid="team-page" className="bg-white">
      {/* HERO */}
      <section className="py-20 lg:py-28 bg-gradient-hero" data-testid="team-hero">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <p className="eyebrow mb-5">The team</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-navy leading-[1.05]">
            Built by people who've <span className="hl-teal">lived it.</span>
          </h1>
          <p className="mt-7 text-lg sm:text-xl text-muted-ink leading-relaxed max-w-2xl mx-auto">
            Generational Health was born from real experience — raising a child with mental health challenges,
            walking alongside people reentering society, and refusing to accept that healing should be reserved for the lucky.
          </p>
        </div>
      </section>

      {/* TEAM MEMBERS */}
      <section className="pb-20 lg:pb-28" data-testid="team-list">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 space-y-24">
          {TEAM.map((m, idx) => (
            <div key={m.id}>
              <article
                id={m.id}
                className="grid lg:grid-cols-5 gap-10 lg:gap-14 items-start"
                data-testid={`team-member-${m.id}`}
              >
                {/* Photo column */}
                <div className="lg:col-span-2">
                  <div className="relative">
                    <div className="absolute -inset-3 bg-teal/15 rounded-[2.5rem] blur-3xl" aria-hidden="true" />
                    <div className="relative rounded-[2rem] overflow-hidden bg-navy aspect-[4/5]">
                      <Avatar member={m} />
                    </div>
                    {m.photoCredit && (
                      <p className="mt-3 text-xs text-muted-ink text-right">
                        Photo: {m.photoCredit}
                      </p>
                    )}
                  </div>
                </div>

                {/* Bio column */}
                <div className="lg:col-span-3">
                  <p className="eyebrow mb-3">{m.title}</p>
                  <h2 className="font-display text-4xl sm:text-5xl text-navy leading-[1.05] mb-3">{m.name}</h2>
                  <p className="text-teal-dark font-bold mb-7">{m.location}</p>

                  <div className="space-y-5 text-[17px] text-muted-ink leading-relaxed">
                    {m.bio.map((p, pi) => (
                      <p key={pi}>{p}</p>
                    ))}
                  </div>

                  {/* Accolades */}
                  <div className="mt-9 p-7 rounded-2xl bg-cream border border-slate-200">
                    <div className="flex items-center gap-3 mb-5">
                      <div className="w-10 h-10 rounded-xl bg-teal-light text-teal flex items-center justify-center">
                        <Award className="w-5 h-5" />
                      </div>
                      <p className="eyebrow">Recognition</p>
                    </div>
                    <ul className="space-y-3">
                      {m.accolades.map((a, ai) => (
                        <li key={ai} className="flex items-start gap-3 text-navy" data-testid={`accolade-${m.id}-${ai}`}>
                          <span className="mt-2 w-1.5 h-1.5 rounded-full bg-teal flex-shrink-0" />
                          <span className="font-medium">{a}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Socials */}
                  {m.socials && m.socials.length > 0 && (
                    <div className="mt-7 flex flex-wrap gap-2">
                      {m.socials.map((s, si) => (
                        <a
                          key={si}
                          href={s.href}
                          target={s.href.startsWith("http") ? "_blank" : undefined}
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-slate-200 text-navy text-sm font-semibold hover:border-teal hover:text-teal transition"
                          data-testid={`social-${m.id}-${si}`}
                        >
                          {s.icon}
                          {s.label}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </article>

              {/* Press & Recognition band — only after Mickey */}
              {m.id === "mickey-coffino" && <PressBand />}
            </div>
          ))}
        </div>
      </section>

      {/* JOIN US CTA */}
      <section className="py-20 lg:py-28 bg-navy text-white relative overflow-hidden" data-testid="team-cta">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-teal/15 rounded-full blur-3xl" aria-hidden="true" />
        <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <Sparkles className="w-10 h-10 text-teal mx-auto mb-6" />
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-6 text-white">
            Want to <span className="hl-teal">build with us?</span>
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto mb-9">
            We're hiring clinicians, engineers, peer supporters, and operators who believe healing should be a right.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/partner" className="btn-primary" data-testid="team-join-cta">
              Join the team <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/about" className="btn-outline-teal !border-white !text-white hover:!bg-white hover:!text-navy" data-testid="team-learn-more">
              <Heart className="w-4 h-4" /> Our mission
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
